import React from 'react';
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import { change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import styled from 'styled-components';
import styledProps from 'styled-props';
import { colors } from '../../../tailwind';
import { Select as Base } from 'rebass';

const FormGroupStyled = styled(FormGroup)`
  width: ${props => (props.width ? props.width : '100%')};
`;

const FormControlStyled = styled(Base)`
  height: 48px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px ${colors.coolGrayLight};
  font-family: Helvetica;
  font-size: 19px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  width: ${props => props.width || '100%'};
  color: ${colors.primaryLight};
  padding-left: 16px;
  padding-right: 16px;

  &::placeholder {
    color: ${colors.primaryFaded};
    opacity: 0.4;
  }
`;

const ControlLabelStyled = styled(ControlLabel)`
  height: 19px;
  font-family: Helvetica;
  text-align: ${props => props.textAlign || 'left'}
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  display: block;
  margin-bottom: 8px;
  color: ${styledProps(colors)};
`;

class Select extends React.Component {
  render() {
    const { change, options, form, name, emptyFirst } = this.props;
    return (
      <FormGroupStyled
        controlId={this.props.id}
        validationState={this.props.validationState}
        width={this.props.width}
      >
        {this.props.label && (
          <ControlLabelStyled grayDarkMedium primary={this.props.primary}>
            {this.props.label}
          </ControlLabelStyled>
        )}
        <FormControlStyled
          componentClass="select"
          value={this.props.value}
          placeholder={this.props.placeholder}
          onChange={async e => {
            await change(form, name, e.target.value);
          }}
        >
          {emptyFirst && <option value="" />}
          {options &&
            options.map((value, key) => {
              let id, itemName;
              if (value.hasOwnProperty('itemName')) {
                id = value.id;
                itemName = value.itemName;
              } else {
                id = key;
                itemName = value;
              }
              return (
                <option value={id} key={key}>
                  {itemName}
                </option>
              );
            })}
        </FormControlStyled>
        <FormControl.Feedback />
        {this.props.helpText && <HelpBlock>{this.props.helpText}</HelpBlock>}
      </FormGroupStyled>
    );
  }
}

const selector = formValueSelector('ListingForm');
export default connect(
  (state, ownProps) => {
    return {
      value: selector(state, ownProps.name),
    };
  },
  { change },
)(Select);



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/Select.js